
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Card, CardContent, CardMedia, Container, Divider, Grid, Stack } from '@mui/material';

export default function AppPromotion() {
    return (
        <Container id = "app" maxWidth = {"xl"}  component='main'>
            <Divider sx={{my:8}}></Divider>
            <Typography component="p" variant="subtitle2" align="center" color="text.secondary">
                App
            </Typography>
            <Grid container columns={12} sx={{pt:8}}>
                <Grid item xs={12} md ={8} sm={8} align="left" >  
                    <Stack spacing={2} >
                        <Typography component="p"  variant="h4"color="secondary" >
                        Descarga nuestra app
                        </Typography>
                        <Typography variant="body1" gutterBottom color="text.secondary">
                        ¡Diga adiós al dolor de cabeza de encontrar un lugar seguro para estacionar! Cqurity le ofrece servicios de acceso a estacionamiento de primer nivel, diseñados para hacerle la vida más fácil. Ya sea que esté apurado para ir a una reunión, ir de compras al centro o planear un día relajante, cubrimos sus necesidades de estacionamiento.
                        </Typography>
                        <Button variant="contained">DESCARGAR APP</Button>
                    </Stack> 
                </Grid>
                <Grid item xs={12} md ={4} sm={4} align="right" >  
                    <img
                        width="296"
                        height="409" 
                        src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fhand_app.png?alt=media&token=364790ef-d870-4053-bbc7-c0189fca4eb7"
                        alt="Live from space album cover"
                    />            
                </Grid>
            </Grid>
        </Container>
    );
}